import Divider from "@mui/material/Divider"
import React from "react"
import { createUseStyles, useTheme } from "react-jss"
import Down from "../../icons/down.svg"
import Up from "../../icons/up.svg"
import { IMonitorCardInterface } from "../../util/interface"
import { timePeriodDescription } from "../../util/StaticData"
import { timePeriodSelectedValueSelector } from "./FilterSlice"
import { Box } from "@mui/material"
import { useAppSelector } from "../../util/hooks"
import CustomIcon from "../../components/CustomIcon"

const useStyles = createUseStyles({
  card: {
    minHeight: 60,
    borderRadius: 10,
    display: "grid",
    gridTemplateColumns: "1fr 0.2fr",
    background: "#FFF",
    flex: 1,
  },
  heading: {
    fontSize: 12,
    height: "75%",
    color: "#3F3F3F",
    fontFamily: ({ theme }: any) => theme.primaryFontFamily,
    fontStyle: "normal",
    fontWeight: 700,
    letterSpacing: "1.2px",
    textTransform: "uppercase",
  },
  caption: {
    fontSize: 10,
    color: "#939393",
    alignSelf: "center",
    textAlign: "center",
    display: "flex",
    justifyContent: "center",
  },
  score: {
    fontSize: 32,
    textAlign: "center",
    marginTop: "auto",
    marginBottom: "auto",
  },
  leftBar: {
    padding: 5,
    display: "grid",
    gridTemplateRows: "1fr 2px 1fr",
    fontSize: "11px",
  },
  thisWeek: {
    color: "#939393",
    fontFamily: ({ theme }: any) => theme.primaryFontFamily,
    fontSize: "10px",
    fontStyle: "normal",
    fontWeight: 600,
    letterSpacing: "1px",
  },
  label: {
    fontSize: 11,
    whiteSpace: "nowrap",
    marginLeft: 10,
  },
  divider: {
    marginLeft: 10,
    marginRight: 15,
    width: "75%",
  },
  captionContainer: {
    marginRight: 15,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  percentage: {
    marginLeft: 5,
  },
  scoreText: {
    fontSize: 16,
    fontWeight: 400,
  },
  pipeLineIcon: {
    position: "relative",
    top: -2,
    marginRight: "3px",
  },
})

function MonitorCard({
  label,
  decription,
  score,
  hasHighLow,
  percentage = 0,
  runs,
  svg,
  pipelines,
}: IMonitorCardInterface) {
  const timePeriodSelectedValue = useAppSelector(
    timePeriodSelectedValueSelector,
  )
  const theme: any = useTheme()
  const classes = useStyles({ theme })

  return (
    <div className={classes.card}>
      {/* Left section of the card with label and description */}
      <div className={classes.leftBar}>
        <Box className={classes.label} sx={{ display: "flex", fontSize: 11 }}>
          {svg && (
            <img
              className={classes.pipeLineIcon}
              height={16}
              width={16}
              src={svg}
              alt={""}
            />
          )}
          {label}
        </Box>
        <Divider className={classes.divider} />
        <div className={classes.captionContainer}>
          {/* Display percentage change if applicable */}
          {hasHighLow && (
            <Box sx={{ display: "flex" }}>
              {percentage !== 0 && (
                <CustomIcon path={percentage > 0 ? Up : Down} alt="" />
              )}
              <span
                className={`${
                  percentage > 0 ? "text-green-600" : "text-red-600"
                } ${percentage === 0 ? "text-orange-400" : ""}`}
              >
                {percentage}%
              </span>
            </Box>
          )}
          <Box
            className={
              label === "PIPELINES" || label === "PIPELINE ID"
                ? classes.thisWeek
                : classes.percentage
            }
          >
            {label === "PIPELINES" || label === "PIPELINE ID"
              ? timePeriodDescription[timePeriodSelectedValue]
              : decription}
          </Box>
        </div>
      </div>
      {/* Right section with score or runs */}
      <div className="text-black font-montserrat text-2xl font-semibold text-2xl text-center mt-auto mb-auto mr-5">
        {label === "PIPELINES"
          ? score
          : label === "PIPELINE ID"
          ? pipelines
          : runs}
        {/* {label === "PIPELINES" && (
          <Tooltip title="Displays the count of Pipeline Run IDs initiated.">
            <span className={classes.scoreText}>{`(${runs})*`}</span>
          </Tooltip>
        )} */}
      </div>
    </div>
  )
}

export default MonitorCard
